import { useRef } from 'react';
import { Box } from '@mui/material';

import { useCanvasViewportSetup, useCanvasEventSetup, useCanvasSetup } from '../setup';
import { CanvasOverlayHost } from './CanvasOverlayHost';

export const Canvas = () => {
  const elementRef = useRef<HTMLDivElement>(null);

  useCanvasSetup(elementRef);
  useCanvasEventSetup();
  useCanvasViewportSetup();

  return (
    <Box sx={{ height: '100%', position: 'relative' }}>
      <Box sx={{ height: '100%' }} ref={elementRef} />
      <CanvasOverlayHost />
    </Box>
  );
};
